

export const API_KEY=process.env.REACT_APP_API_KEY;
export const API_URL=process.env.REACT_APP_API_URL;

console.log("key:",API_KEY)
console.log("url:",API_URL)